"use client";

import Image from "next/image";
import Link from "next/link";
import React, { useState, useEffect } from "react";
import ReactStars from "react-stars";

const DefaultCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    {
      id: 1,
      title: "... courteous & professional.",
      href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      description:
        "Mushtaq of Alpha Appraisals visited our home to do an appraisal for an estate settlement. He was prompt, courteous and extremely professional in carrying out his work.",
      author: {
        name: "Dave K.",
        href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      },
    },
    {
      id: 2,
      title: "... one day ahead of schedule.",
      href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      description:
        "I called Alpha for a home appraisal that was needed quickly and he was able to come the next day on a Saturday. The appraisal report was delivered one day ahead of schedule and it was thorough and of professional quality.",
      author: {
        name: "Chris C.",
        href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      },
    },
    {
      id: 3,
      title: "... such an amazing man.",
      href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      description:
        "I don't usually write reviews but for Alpha Appraisals, I had to. Mr Khan is such an amazing man. Such an honest and fair person. Thank you for your help through my difficult time.",
      author: {
        name: "Marcio O.",
        href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      },
    },
    {
      id: 4,
      title: "Very fast & efficient ...",
      href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      description:
        "Very fast and efficient appraisal service, thorough detail and fully valid for legal use. Appraiser was accessible and available even on short notice.",
      author: {
        name: "Jeffrey C.",
        href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      },
    },
    {
      id: 5,
      title: "Awesome communication ...",
      href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      description:
        "Had a great experience working with Alpha Appraisals. Awesome communication, very fair pricing, services delivered as promised and very quick turn around times. Would highly recommend.",
      author: {
        name: "Mohammad A.",
        href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      },
    },
    {
      id: 6,
      title: "... robust & well-documented.",
      href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      description:
        "My appraisal report was robust, detailed and well-documented. The report was completed in a timely manner. Mr. Khan's work was excellent and I appreciated his explanations. Highly recommend.",
      author: {
        name: "Michelle D.",
        href: "https://maps.app.goo.gl/LQP7RigWRFxWkwLs6",
      },
    },
  ];
  useEffect(() => {
    const nextSlide = () => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    };

    const interval = setInterval(nextSlide, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <a
      href="#reviews"
      alt="Google Reviews For Alpha Appraisals Inc"
      className=" grid justify-evenly items-center  mb-2 sm:mb-0 w-full    bg-black shadow-lg rounded-lg transition-transform transform hover:scale-105"
    >
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`   ${
            index === currentSlide ? "" : "hidden"
          } transition-opacity w-max duration-700 ease-in-out`}
        >
          <div className="flex  items-center justify-evenly  w-full  ">
            <div className="text-white flex text-xs ">
              <Image
                src="/google_icon.png"
                height={20}
                width={20}
                alt="google business logo"
                className="h-4 w-auto pr-1"
              />{" "}
              Verified Reviews
            </div>
            <span
              role="img"
              aria-label="Shield"
              alt="Alpha Appraisals Reviews"
              className="text-base text-center flex w-fit pr-3"
            >
              <span className="text-white  text-base px-1 font-semibold  ">
                {" "}
                5.0
              </span>
              <ReactStars count={5} value={5} />{" "}
              <p className="text-xs	 text-zinc-600 ">(150)</p>
            </span>

            <div className="text-white hidden sm:flex text-xs text-center  w-56 overflow-hidden text-overflow-ellipsis whitespace-nowrap">
              <span className="italic pr-2">"{slide.title}"</span> -{" "}
              {slide.author.name}
            </div>
          </div>
        </div>
      ))}{" "}
    </a>
  );
};

export default DefaultCarousel;
